var VulnerabilitySeverity = /* @__PURE__ */ ((VulnerabilitySeverity2) => {
  VulnerabilitySeverity2["Critical"] = "Critical";
  VulnerabilitySeverity2["High"] = "High";
  VulnerabilitySeverity2["Medium"] = "Medium";
  VulnerabilitySeverity2["Low"] = "Low";
  VulnerabilitySeverity2["Negligible"] = "Negligible";
  VulnerabilitySeverity2["None"] = "None";
  VulnerabilitySeverity2["Unknown"] = "Unknown";
  return VulnerabilitySeverity2;
})(VulnerabilitySeverity || {});
const VulnerabilityOrder = {
  ["Critical" /* Critical */]: 0,
  ["High" /* High */]: 1,
  ["Medium" /* Medium */]: 2,
  ["Low" /* Low */]: 3,
  ["Negligible" /* Negligible */]: 4,
  ["None" /* None */]: 5,
  ["Unknown" /* Unknown */]: 6
};

export { VulnerabilityOrder, VulnerabilitySeverity };
//# sourceMappingURL=types.esm.js.map
